import { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

import MuiTable from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import Typography from "@material-ui/core/Typography"
import MuiLink from "@material-ui/core/Link"

import { useAdminState } from "../Context"
import { useAppSelector } from "common/hooks"
import AdminLoader from "components/partials/AdminLoader"
import AdminEmptyMessage from "components/partials/AdminEmptyMessage"
import AdminTableContainer from "components/partials/AdminTableContainer"
import AdminActionContainer from "components/partials/AdminActionContainer"
import AdminNavigation from "components/partials/AdminNavigation"
import MultiSelectActions from "./MultiSelectActions"
import Row from "./Row"
import Header from "./Header"
import Pagination from "./Pagination"

const Table = () => {
  const { rows, isLoading } = useAdminState()
  const [showCompany, setShowCompany] = useState()
  const { user: currentUser } = useAppSelector(state => state.auth)

  useEffect(() => {
    if (isLoading) return
    if (typeof showCompany === "boolean") return

    // We only want to set the state once. Even the
    // rows are changing.
    setShowCompany(() => !areAllUsersHasTheSameCompany(rows))
  }, [isLoading, showCompany, rows])

  const _showCompany = Boolean(showCompany)
  let showEnabled = currentUser?.role === "Superadmin"

  return (
    <>
      <AdminNavigation />

      <AdminTableContainer>
        <MuiTable>
          <Header showCompany={_showCompany} showEnabled={showEnabled} />
          <TableBody>
            <Rows showCompany={_showCompany} showEnabled={showEnabled} />
          </TableBody>
        </MuiTable>
      </AdminTableContainer>

      <AdminActionContainer>
        <Pagination />
        <MultiSelectActions />
      </AdminActionContainer>
    </>
  )
}

function areAllUsersHasTheSameCompany(users) {
  if (!users.length) return true
  if (!users[0].company) return false

  return users.every(user => {
    if (!user.company) return false
    return user.company.name === users[0].company?.name
  })
}

const Rows = props => {
  const { t } = useTranslation()
  const location = useLocation()
  const { rows, isLoading } = useAdminState()

  if (isLoading) {
    return <AdminLoader />
  }

  if (!rows.length) {
    return (
      <AdminEmptyMessage title={t("view.adminUsers.modifyFilterTitle")}>
        <Typography>
          {t("view.adminUsers.modifyFilterMessage1")}&nbsp;
          <MuiLink to={location.pathname} component={Link}>
            {t("view.adminUsers.modifyFilterMessage2")}
          </MuiLink>
          .
        </Typography>
      </AdminEmptyMessage>
    )
  }

  return (
    <>
      {rows.map(row => (
        <Row key={row.id} data={row} {...props} />
      ))}
    </>
  )
}

export default Table
